<template>
    <div class="main-content">
        <the-header :title="t('Edit user')"/>
        <nav-body :links="nav" v-on:changeTitle="title = $event">
            <router-view></router-view>
        </nav-body>
    </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import NavBody from '../../../admin/Layout/NavBody'

    export default {
        components: {
            TheHeader,
            NavBody,
        },
        mounted() {
            if (this.$route.name === 'createUser') {
                this.$store.commit('users/resetItem');
            } else {
                this.$store.dispatch('users/get', this.$route.params.id);
            }
        },
        data() {
            return {
                loading: true,
                nav: [
                    {
                        name: this.t('Main info'),
                        icon: 'user',
                        route: {name: 'manageUserDetails', params: {id: this.$route.params.id}},
                    }, {
                        name: this.t('Permissions'),
                        icon: 'lock',
                        route: {name: 'manageUserPermissions', params: {id: this.$route.params.id}},
                        visible: () => {
                            return this.hasPermission('PermissionsTitan', 'CRUD');
                        }
                    }, {
                        name: this.t('Change password'),
                        icon: 'lock',
                        route: {name: 'changeUserPassword', params: {id: this.$route.params.id}},
                        visible: () => {
                            return this.hasPermission('SetUserPasswordTitan', 'CRUD');
                        }
                    }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/Manage.vue